import { IXepLoaiChungChi } from "../../../model/response/category/IXepLoaiChungChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXepLoaiChungChiActionObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IXepLoaiChungChi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as IXepLoaiChungChi | undefined,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IXepLoaiChungChi,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

}

export const eXepLoaiChungChiActionIds = generateActionTypeIds(eXepLoaiChungChiActionObj, "XEP_LOAI_CHUNG_CHI");
export type IXepLoaiChungChiActionTypes = IGenericActionType<typeof eXepLoaiChungChiActionObj, "XEP_LOAI_CHUNG_CHI">;